/**
 * #142 · La puerta de `/labels`, que no es la misma para todos.
 *
 * El back-office entra a **Órdenes** (su compra al impresor) y una marca a
 * **Pedidos** (lo que le pide a XYVONA). El porqué está en `LabelsTabs.tsx`.
 *
 * Se resuelve acá y no con dos rutas distintas para que el enlace del menú y
 * cualquier link viejo a `/labels` sigan llevando a la pantalla correcta: dos
 * rutas obligarían a saber quién sos ANTES de armar el href, y eso lo tendría
 * que repetir cada lugar que enlace al módulo.
 */
import type { ReactNode } from 'react';

import { useAuth } from '@/auth/useAuth';
import { BACKOFFICE_SLUG } from '@/layout/nav';
import { LabelOrdersPage } from './LabelOrdersPage';
import { RollRequestsPage } from './RollRequestsPage';

export function LabelsIndexPage(): ReactNode {
  const { claims } = useAuth();
  return claims?.tenant === BACKOFFICE_SLUG ? <LabelOrdersPage /> : <RollRequestsPage />;
}
